import { render, staticRenderFns } from "./CategoriaLista.vue?vue&type=template&id=121e2779&scoped=true"
import script from "./CategoriaLista.vue?vue&type=script&lang=js"
export * from "./CategoriaLista.vue?vue&type=script&lang=js"
import style0 from "./CategoriaLista.vue?vue&type=style&index=0&id=121e2779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e2779",
  null
  
)

export default component.exports